import { IconCancel } from '@op/opds.opux-icons/action';
import { IconCafe, IconPrize } from '@op/opds.opux-icons/misc';
import {
  IconAmusementpark,
  IconHobbies,
  IconCarservice,
} from '@op/opds.opux-icons/expenses';
import { IconFunds } from '@op/opds.opux-icons/finance';
import { Message } from '@messageformat/react';
import { ReactElement, useMemo, useState } from 'react';
import { Breakpoint, BreakpointListener, Breakpoints, Col, Row } from '@op/opds.opux';
import { space } from '@op/opds.tokens';
import { ReactComponent as Image021 } from '../../images/OP_symbolikuvitus_128_021.svg';
import { ReactComponent as Image013 } from '../../images/OP_symbolikuvitus_96_013.svg';
import { ReactComponent as Image072 } from '../../images/OP_symbolikuvitus_96_072.svg';
import { ReactComponent as Image008 } from '../../images/OP_symbolikuvitus_128_008.svg';
import { ReactComponent as Image030 } from '../../images/OP_symbolikuvitus_96_030.svg';
import { ReactComponent as Image006 } from '../../images/OP_symbolikuvitus_128_006.svg';

type Content = {
  mobile: boolean;
};

const PathToInvestor = (): ReactElement => {
  const [breakpoint, setBreakpoint] = useState<Breakpoint | null>(null);

  const content = breakpoint?.content ? (breakpoint.content as Content) : null;

  const breakpoints: Breakpoints = useMemo(() => {
    return [
      { from: 0, to: 736, content: { mobile: true } },
      {
        from: 737,
        to: Number.MAX_SAFE_INTEGER,
        content: { mobile: false },
      },
    ];
  }, []);
  return (
    <BreakpointListener breakpoints={breakpoints} onChange={setBreakpoint}>
      <div className="investoracademy-path-to-investor-container">
        <div
          className="investoracademy-path-to-investor-row"
          style={{ position: 'relative' }}
        >
          <div
            className="investoracademy-path-to-investor-column \
        investoracademy-path-to-investor-oddColumn"
          >
            <IconCancel
              onDarkBg
              className="investoracademy-path-to-investor-icon \
            investoracademy-path-to-investor-iconToCenterBottom"
            />
            <Row>
              <Col xs={4} />
              <Col
                xs={10}
                md={4}
                className="investoracademy-path-to-investor-text"
                style={{ verticalAlign: 'middle', justifyContent: 'center' }}
              >
                <h3>
                  <Message id="course1.start.heading" />
                </h3>
                <p>
                  <Message id="course1.start.body" />
                </p>
              </Col>
              <Col xs={4} style={{ position: 'relative' }}>
                <Image013
                  style={{ height: '96px', position: 'absolute', bottom: '0px' }}
                  className="investoracademy-svg-hidden-in-mobile"
                  aria-hidden="true"
                />
              </Col>
            </Row>
          </div>
        </div>
        <div className="investoracademy-path-to-investor-row">
          <div
            className="investoracademy-path-to-investor-column \
          investoracademy-path-to-investor-textToRight \
          investoracademy-path-to-investor-arc"
            style={
              content?.mobile
                ? {
                    order: 2,
                  }
                : {
                    order: 2,
                    padding: `${space.xxxxl} ${space.xl}`,
                    position: 'relative',
                  }
            }
          >
            <IconCafe
              onDarkBg
              className="investoracademy-path-to-investor-icon \
            investoracademy-path-to-investor-iconToRightCenter"
            />
            <div className="investoracademy-path-to-investor-text">
              <h3>
                <Message id="course1.leg1.heading" />
              </h3>
              <p>
                <Message id="course1.leg1.body" />
              </p>
            </div>
            <Image008
              style={{
                height: '128px',
                position: 'absolute',
                bottom: '20px',
                left: '20px',
              }}
              className="investoracademy-svg-hidden-in-mobile"
              aria-hidden="true"
            />
          </div>
          <div
            className="investoracademy-path-to-investor-column \
          investoracademy-path-to-investor-oddColumn"
            style={content?.mobile ? {} : { padding: `${space.default} ${space.xl}` }}
          >
            <Image072
              style={{
                height: '96px',
                position: 'absolute',
                bottom: '300px',
                left: '0px',
              }}
              className="investoracademy-svg-hidden-in-mobile"
              aria-hidden="true"
            />
            <div
              style={content?.mobile ? {} : { paddingTop: '160px', textAlign: 'center' }}
            >
              <IconAmusementpark
                onDarkBg
                className="investoracademy-path-to-investor-icon \
            investoracademy-path-to-investor-iconNegative"
              />
              <div
                className="investoracademy-path-to-investor-text \
          investoracademy-path-to-investor-textNegative"
              >
                <h3>
                  <Message id="course1.danger1.heading" />
                </h3>
                <p>
                  <Message id="course1.danger1.body" />
                </p>
                <div
                  className="investoracademy-path-to-investor-loopToLeft"
                  style={{
                    order: '1',
                    height: '70%',
                    position: 'absolute',
                    bottom: '0px',
                    left: '0px',
                    width: '100%',
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="investoracademy-path-to-investor-row">
          <div
            className="investoracademy-path-to-investor-column \
        investoracademy-path-to-investor-textToRight \
        investoracademy-path-to-investor-borderRight"
          >
            <IconHobbies
              onDarkBg
              className="investoracademy-path-to-investor-icon \
            investoracademy-path-to-investor-iconToRightCenter"
            />
            <div className="investoracademy-path-to-investor-text">
              <h3>
                <Message id="course1.leg2.heading" />
              </h3>
              <p>
                <Message id="course1.leg2.body" />
              </p>
            </div>
          </div>
          <div className="investoracademy-path-to-investor-column">
            <Image030
              style={{ height: '96px', position: 'absolute', left: '80px' }}
              className="investoracademy-svg-hidden-in-mobile"
              aria-hidden="true"
            />
          </div>
        </div>
        <div className="investoracademy-path-to-investor-row">
          <div
            className="investoracademy-path-to-investor-column-only-desktop \
        investoracademy-path-to-investor-borderRight \
        investoracademy-path-to-investor-textToRight"
          >
            <IconFunds
              onDarkBg
              className="investoracademy-path-to-investor-icon \
            investoracademy-path-to-investor-iconToRightCenter \
            investoracademy-svg-hidden-in-mobile"
            />
            <Image021
              style={{ height: '128px' }}
              className="investoracademy-svg-hidden-in-mobile"
              aria-hidden="true"
            />
          </div>
          <div
            className="investoracademy-path-to-investor-column \
        investoracademy-path-to-investor-oddColumn"
          >
            <IconFunds
              onDarkBg
              className="investoracademy-path-to-investor-icon \
            investoracademy-path-to-investor-iconToRightCenter \
            investoracademy-svg-hidden-in-desktop"
            />
            <div className="investoracademy-path-to-investor-text">
              <h3>
                <Message id="course1.leg3.heading" />
              </h3>
              <p>
                <Message id="course1.leg3.body" />
              </p>
            </div>
          </div>
        </div>
        <div className="investoracademy-path-to-investor-row">
          <div
            className="investoracademy-path-to-investor-column \
          investoracademy-path-to-investor-loopToRight"
            style={{ order: '2' }}
          >
            <IconCarservice
              onDarkBg
              className="investoracademy-path-to-investor-icon \
            investoracademy-path-to-investor-iconNegative"
            />
            <div
              className="investoracademy-path-to-investor-text \
          investoracademy-path-to-investor-textNegative"
            >
              <h3>
                <Message id="course1.danger2.heading" />
              </h3>
              <p>
                <Message id="course1.danger2.body" />
              </p>
            </div>
          </div>
          <div
            className="investoracademy-path-to-investor-column \
          investoracademy-path-to-investor-oddColumn"
            style={{ order: '1' }}
          >
            <Image006
              style={{
                height: '128px',
                position: 'absolute',
                left: '0px',
                bottom: '260px',
              }}
              className="investoracademy-svg-hidden-in-mobile"
              aria-hidden="true"
            />
            <div className="investoracademy-path-to-investor-halfArc" />
            <IconPrize
              onDarkBg
              className="investoracademy-path-to-investor-icon \
            investoracademy-path-to-investor-iconPositive"
            />
            <div
              className="investoracademy-path-to-investor-text \
          investoracademy-path-to-investor-textPositive"
            >
              <h3>
                <Message id="course1.end.heading" />
              </h3>
              <p>
                <Message id="course1.end.body" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </BreakpointListener>
  );
};

export default PathToInvestor;
